import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { audienceChannelSourcesQueryKeys } from './query-keys';

export type TDeleteAudienceChannelSourceParams = {
  id: string;
};

export function deleteAudienceChannelSource({
  id,
}: TDeleteAudienceChannelSourceParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/audience_channel_sources/${id}`);
}

type MutationFn = typeof deleteAudienceChannelSource;

type UseDeleteAudienceChannelSourceParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteAudienceChannelSource({
  config,
}: UseDeleteAudienceChannelSourceParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification('La fuente de audiencia no existe o ya ha sido eliminada');
      }
      if (status === 403) {
        return addErrorNotification('No tienes permisos para eliminar esta fuente de audiencia');
      }
      addErrorNotification('No se ha podido eliminar la fuente de audiencia');
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: audienceChannelSourcesQueryKeys.all });
      addSuccessNotification('La fuente de audiencia se ha eliminado correctamente');
    },
    ...config,
    mutationFn: deleteAudienceChannelSource,
  });
}
